module.exports = __webpack_public_path__ + "static/media/apercu-bold_italic.24d1f375.woff2";